import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  width: "26",
  height: "26",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_2 = {
  key: 1,
  width: "26",
  height: "26",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_3 = { class: "text-[17px] font-bold text-slate-900 mb-2 text-center" }
const _hoisted_4 = { class: "text-[13.5px] text-slate-500 mb-6 leading-relaxed text-center" }
const _hoisted_5 = { class: "flex gap-2.5" }


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmDialog',
  props: {
    modelValue: { type: Boolean },
    title: {},
    message: {},
    confirmLabel: {},
    cancelLabel: {},
    variant: {},
    iconVariant: {}
  },
  emits: ["confirm", "cancel", "update:modelValue"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "popup" }, {
      default: _withCtx(() => [
        (__props.modelValue)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-[100]",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('cancel')))
            }, [
              _createElementVNode("div", {
                class: "bg-white rounded-2xl px-7 pt-8 pb-6 w-[380px] max-w-[calc(100vw-32px)] shadow-2xl",
                onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4", __props.iconVariant === 'danger' ? 'bg-red-50 text-red-600' : 'bg-blue-50 text-blue-700'])
                }, [
                  (__props.iconVariant === 'danger')
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[4] || (_cache[4] = [
                        _createElementVNode("path", { d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" }, null, -1),
                        _createElementVNode("line", {
                          x1: "12",
                          y1: "9",
                          x2: "12",
                          y2: "13"
                        }, null, -1),
                        _createElementVNode("line", {
                          x1: "12",
                          y1: "17",
                          x2: "12.01",
                          y2: "17"
                        }, null, -1)
                      ]))]))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_2, [...(_cache[5] || (_cache[5] = [
                        _createElementVNode("circle", {
                          cx: "12",
                          cy: "12",
                          r: "10"
                        }, null, -1),
                        _createElementVNode("line", {
                          x1: "12",
                          y1: "8",
                          x2: "12",
                          y2: "12"
                        }, null, -1),
                        _createElementVNode("line", {
                          x1: "12",
                          y1: "16",
                          x2: "12.01",
                          y2: "16"
                        }, null, -1)
                      ]))]))
                ], 2),
                _createElementVNode("h3", _hoisted_3, _toDisplayString(__props.title), 1),
                _createElementVNode("p", _hoisted_4, _toDisplayString(__props.message), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    class: "flex-1 py-2.5 rounded-[10px] border border-slate-200 bg-white text-slate-600 text-[13.5px] font-semibold transition-all duration-150 hover:bg-slate-50 hover:border-slate-300",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
                  }, _toDisplayString(__props.cancelLabel ?? 'Batal'), 1),
                  _createElementVNode("button", {
                    class: _normalizeClass(["flex-1 py-2.5 rounded-[10px] border-none text-white text-[13.5px] font-semibold transition-opacity duration-150 hover:opacity-90", __props.variant === 'danger' ? 'bg-red-600' : 'bg-blue-800']),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm')))
                  }, _toDisplayString(__props.confirmLabel ?? 'Ya'), 3)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})